import React from 'react';
import { connect } from 'react-redux';
import { setLoading } from '../../commons/components/application/miscActions'
import { loginSuccess, loginFail } from './loginActions'
import { getToken, checkExistingSession } from '../../api/oAuthApi'
import { getFreeTrialStatus } from '../../api/freeTrialApi'
import { envConfig } from '../../config/config.js';
import { checkFirstLogin } from '../../api/administratorApi'
import { withRouter } from 'react-router-dom'
import Login from './Login';
import Loading from '../../commons/components/utils/Loading';
import withEventTracking from '../../config/withEventTracking';
import { trackers } from "../../config/withEventTracking";
import { getTokenSSO } from '../../api/securityApi';

const axiosErrorHandler = (props) => (error) => {
    if (error.response && error.response.data) {
        //FIXME no tiene que setearse el texto acá
        if (error.response.status === 400) {
            switch (error.response.data.error_description) {
                case 'User is disabled':
                    error.message = 'Usuario invalido o deshabilitado'
                    break;
                default:
                    error.message = 'Usuario o contraseña inválidos'

            }
        }
        // props.loginFail(error);
    }
    return error;
};
class LoginContainer extends React.Component {

    constructor(props) {
        super(props);
        this.loginRequest = this.loginRequest.bind(this)
        this.state = {
            isLoading: true
        }
    }


    loginRequest = (data) => {
        this.props.setLoading(true);
        const { user, password } = data;

        getFreeTrialStatus(user).then((response) => {
            var data = response.data.data;
            if (data.action === "REDIRECT") {
                window.location.href = envConfig.purchaseLanding + "?redirectUrl=" + data.url;
            } else {
                getToken(user, password, axiosErrorHandler(this.props)).then((response) => {
                    const token = response.data.data.token; // JWT principal
                    const admin = response.data.data.admin; // datos básicos
                    this.props.loginSuccess({ 
                        administrator: admin, 
                        token: token
                    }, '');
                    this.mixpanelHandler(admin)
                    this.props.trackEvent("login", {}, false, [trackers.BACKEND])
                });
            }
        });
    }

    appendSeparatorToUrl(url) {
        if (url.indexOf("?") > -1)
            return url + "&";
        else
            return url + "?";
    }

    mapAdminRole = (admin) => {
        if (admin.objectAccess === "ALL") return "MOTU";
        if (admin.objectAccess === "SELF") return "locationBU";
        if (admin.objectAccess === "COMPANY") {
            if (!admin.companyRol) return "unknown";
            switch (admin.companyRol) {
                case "DM": return "DM";
                case "COMPANY_BU": return "companyBU";
                case "LOCATION_BU": return "locationBU";
                default: return "unknown";
            }
        }
        return "unknown";
    };

    mixpanelHandler = (admin) => {
        const { mixpanel } = this.props;
        mixpanel.identify(admin.id);

        const role = this.mapAdminRole(admin);
        
        mixpanel.people.set({
            "$email": admin.email,    // only reserved properties need the $
            "$first_name": admin.name,
            "$last_name": admin.lastname,
            "$avatar": "https://cdn-admin.rayapp.io/static/img/avatars/" + admin.avatar, // Hay
            "username": admin.username,
            "company_id": admin.companyId,
            "profiles": admin.profiles.map(profile => ({id: profile.id, objectAccess: profile.objectAccess})),
            "role": role,
        });
    }

    renderLogin() {
        this.setState({ isLoading: false });
        document.getElementById('wrapper').classList.add("login-set")
    }

    componentDidMount() {
        checkExistingSession()
            .then(async (response) => {
                console.log('checkExistingSession success', response);
                // Obtener token SSO para PHP cuando hay sesión existente
                let ssoToken = null;
                try {
                    const ssoResponse = await getTokenSSO('php', response.companyId);
                    ssoToken = ssoResponse.data.data.token;
                } catch (error) {
                    console.warn('No se pudo obtener token SSO:', error);
                }
                
                this.props.loginSuccess({ 
                    administrator: response, 
                    token: ssoToken
                }, '');
                this.mixpanelHandler(response);
            })
            .catch((error) => {
                console.log('checkExistingSession error', error);
                const params = new URLSearchParams(this.props.location.search);
                let username = params.get('username');
                let token = params.get('token');
                if (username && token) {
                    checkFirstLogin(username, token, (err) => {
                        window.location.href = envConfig.v2LoginUrl;
                    }).then((res) => {
                        if (res.data.data.madeTheFirstLogin === false) {
                            this.props.history.push(`/setPassword?username=${username}&token=${token}&firstLogin=true`);
                        } else {
                            this.renderLogin()
                        }
                    }).catch(() => this.renderLogin())
                } else {
                    this.renderLogin()
                }
            });
    }

    componentWillUnmount() {
        document.getElementById('wrapper').classList.remove("login-set");
    }

    render() {
        const params = new URLSearchParams(this.props.location.search);
        if (this.props.login.loggedIn) {
            // si tengo el parametro originalUrl tengo que forwardear luego del login a la pagina especificada
            let redirectTo = params.get('originalUrl') === null ? this.getHome() : decodeURIComponent(params.get('originalUrl').trim());
            //hasTodoTask().then(res => {
                //if (!!res.data.data) {
                //   redirectTo = "/checklist";
                //}
                //else 
				if (redirectTo.length === 0 || redirectTo === '/') {
                    redirectTo = this.getHome();
                }


                // si el redirect es a php, agrego sso y redirijo
                // sino solo cambio de ruta en el router
                if (redirectTo.indexOf(".php") > -1 || redirectTo.indexOf("v1") > -1) {
                    // Paid users need to have the correct JWT token
                    checkExistingSession(true).then((auth) => {
                        const jwtToken = auth.token;
                        let url = this.appendSeparatorToUrl(redirectTo) + `sso=${jwtToken}`;
                        window.location.href = url;
                    });
                    return null; // Stop rendering
                } else {
                    const index = redirectTo.indexOf("rayapp.io")
                    if (index !== -1) {
                        redirectTo = redirectTo.substring(index + 9)
                    }
                    this.props.history.push(redirectTo);
                }
            //})

            return null;
        }
        let username = params.get('username');

        return (
            <>{this.state.isLoading
                ? <Loading fullScreen={true} loading={this.state.isLoading} />
                : <Login handleLogin={this.loginRequest} initialValues={{ user: username }} />
            }</>
        );
    }

    getHome = () => {
        return '/dashboard'
    }

}

const mapStateToProps = (state) => {
    return state
};

export default withRouter(connect(mapStateToProps, { loginSuccess, loginFail, setLoading })(withEventTracking(LoginContainer)))
